import React from 'react';
interface SkillTagProps {
  name: string;
  level?: 'beginner' | 'intermediate' | 'advanced' | 'expert';
  category?: string;
}
const SkillTag: React.FC<SkillTagProps> = ({
  name,
  level = 'intermediate',
  category
}) => {
  const getLevelStyles = () => {
    switch (level) {
      case 'beginner':
        return 'bg-secondary-100 text-secondary-800';
      case 'intermediate':
        return 'bg-primary-100 text-primary-800';
      case 'advanced':
        return 'bg-primary-200 text-primary-900';
      case 'expert':
        return 'bg-primary-300 text-primary-900';
      default:
        return 'bg-primary-100 text-primary-800';
    }
  };
  const getCategoryStyles = () => {
    switch (category) {
      case 'technical':
        return 'bg-secondary-100 text-secondary-800';
      case 'analytical':
        return 'bg-primary-50 text-primary-800';
      case 'ai':
        return 'bg-primary-100 text-primary-800';
      case 'soft':
        return 'bg-secondary-100 text-secondary-800';
      case 'domain':
        return 'bg-primary-50 text-primary-800';
      default:
        return 'bg-secondary-100 text-secondary-800';
    }
  };
  const styles = category ? getCategoryStyles() : getLevelStyles();
  return <span className={`inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium ${styles} transition-all duration-300 hover:shadow-sm`} data-id="element-131">
      {name}
    </span>;
};
export default SkillTag;